export const STICKER_CATEGORIES = {
	all: "Все",
	// v0.4.0
	// logos: "Logos",
	flags: "Флаги",
	shapes: "Фигуры",
};
